import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    set: function set(_ref, info) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref.state, dispatch = _ref.dispatch;
                // store 赋值
                state.info = info; // 持久化

                _context.next = 4;
                return dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: 'user.info',
                  value: info,
                  user: true
                }, {
                  root: true
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    load: function load(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = _ref2.state, dispatch = _ref2.dispatch;
                _context2.next = 3;
                return dispatch('d2admin/db/get', {
                  dbName: 'sys',
                  path: 'user.info',
                  defaultValue: {},
                  user: true
                }, {
                  root: true
                });

              case 3:
                state.info = _context2.sent;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};